<template>
  <pnet-validation-observer>
    <div>
      <div v-if="label" class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for>
              <small>{{label}}</small>
            </label>
            <select
              v-model="option"
              class="custom-select"
              @change="changedValue"
              :name="label"
              :rules="{required:true}"
              :customMessages="{required:'Il campo deve essere valorizzato.'}"
            >
              <option
                v-for="option in JSON.parse(JSON.stringify(options))"
                v-bind:key="option.code"
                :value="option"
              >{{ option.description }}</option>
            </select>
          </div>
        </div>
      </div>

      <select
        v-if="!label"
        class="custom-select"
        v-model="option"
        @change="changedValue"
        :rules="{required:true}"
      >
        <option
          v-for="option in JSON.parse(JSON.stringify(options))"
          v-bind:key="option.code"
          :value="option"
        >{{ option.description }}</option>
      </select>
    </div>
  </pnet-validation-observer>
</template>

<script lang="js">
import Vue from "vue";
export default Vue.extend({
  props: ["label", "value", "options","handlerOnChange"],
  data() {
    return {
      option: null
    }
  },
  mounted() {
    this.option = this.value;
  },
  methods: {
    changedValue: function(e) {
      this.$emit('input',this.option);
      if (this.handlerOnChange){
        this.handlerOnChange()
      }
    }
  },
  watch: {
    value: {
      deep: true,      
      handler() {
        this.option = this.value;
      }
    }
  }
});
</script>
